import * as React from "react";
import Icon from "../MyIcon";
export const StarIcon = (props) => {
    const { color, size } = props;
    return React.createElement(Icon, { size: size || "10px", type: "ic_star", color: color || "#FFB200" });
};
